export default class Home {
  constructor() {
  	// Home
  }
}